export default __webpack_public_path__ + "static/logo_home-42a302cd4eee30e3457d6bf4cec77295.png";